import React from "react";
import "./hierarchyChain.css";

/**
 * nodes: [{ label: "Franchise Manager", name: "Rahul Sharma", active: false }, ...]
 * Renders left-to-right, oldest ancestor first, current level highlighted.
 */
const HierarchyChain = ({ nodes = [] }) => {
  if (!nodes.length) return null;

  const getInitials = (name) => {
    if (!name) return "—";
    const parts = name.trim().split(" ");
    return parts.length > 1
      ? `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase()
      : name.slice(0, 2).toUpperCase();
  };

  return (
    <div className="vfm-hierarchy-chain">
      {nodes.map((node, idx) => (
        <React.Fragment key={idx}>
          <div className={`vfm-hierarchy-node ${node.active ? "vfm-hierarchy-node--active" : ""}`}>
            <div className="vfm-hierarchy-avatar">
              {getInitials(node.name)}
            </div>
            <div className="vfm-hierarchy-text">
              <span className="vfm-hierarchy-label">{node.label}</span>
              <span className="vfm-hierarchy-name">{node.name || "—"}</span>
            </div>
          </div>

          {idx < nodes.length - 1 && (
            <div className="vfm-hierarchy-connector">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </div>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default HierarchyChain;